export const adminClinicTableCeilWidth = {
  sla: '55px',
  info: '357px',
  serviceType: '241px',
  address: '205px',
  status: '97px',
};
